/* sucrase/dist/esm/util/removeMaybeImportAttributes.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.removeMaybeImportAttributes = removeMaybeImportAttributes;
    const keywords_1 = require("99ff836c64") /* ../parser/tokenizer/keywords */;
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    /**
     * Starting at a potential `with` or (legacy) `assert` token, remove the import
     * attributes if they exist.
     */
    function removeMaybeImportAttributes(tokens) {
        if (tokens.matches2(types_1.TokenType._with, types_1.TokenType.braceL) ||
            (tokens.matches2(types_1.TokenType.name, types_1.TokenType.braceL) && tokens.matchesContextual(keywords_1.ContextualKeyword._assert))) {
            // assert
            tokens.removeToken();
            // {
            tokens.removeToken();
            tokens.removeBalancedCode();
            // }
            tokens.removeToken();
        }
    }
}
